import { CloudCode } from './cloudcode';
import { Constants } from '../models/constants';

export class SlackService {

  static submitSlackAuthCode(
    authCode: string,
    mobileEventCode: string,
    successCallback: (slackChannel: string) => void,
    errorCallback: (msg: string) => void) {

    const redirectUri = Constants.DEV_MODE ? Constants.DEV_SLACK_REDIRECT_URI : 'https://app.getshortcut.co/setup-slack'

    CloudCode.run('submitSlackAuthCode',
      {
        authCode,
        mobileEventCode,
        redirectUri
      },
      (slackChannel: string) => {
        successCallback(slackChannel);
      },
      (msg: string) => {
        errorCallback(msg);
      });
  }

}